import { Disclosure } from "@headlessui/react";
import {
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import {
  ChartPieIcon,
  HomeIcon,
  PresentationChartBarIcon,
  BanknotesIcon,
  LightBulbIcon,
  FunnelIcon,
  CursorArrowRaysIcon,
  UserGroupIcon,
  ChartBarSquareIcon,
  RocketLaunchIcon,
  CpuChipIcon,
  EnvelopeIcon,
  PaintBrushIcon,
  PaperAirplaneIcon,
  ShieldCheckIcon,
  Squares2X2Icon,
  Cog6ToothIcon,
  CogIcon,
  ViewfinderCircleIcon,
  InformationCircleIcon,
  BuildingOfficeIcon,
  PresentationChartLineIcon,
  StopCircleIcon,
  ArrowPathRoundedSquareIcon,
  CodeBracketSquareIcon,
  ClipboardDocumentCheckIcon,
  ChartBarIcon,
  BookmarkSquareIcon,
} from "@heroicons/react/24/outline";

import { NavLink } from "react-router-dom";
import { ClassNames } from "../../helper";
import { useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

const navigationObj = [
  { name: "Dashboard", href: "", icon: HomeIcon, current: true },
  {
    name: "Marketing performance",
    icon: PresentationChartBarIcon,
    current: false,
    children: [
      {
        name: "Ads campaign performance",
        href: "marketing",
        current: false,
        icon: BanknotesIcon,
      },
      {
        name: "Content performance",
        href: "content",
        current: false,
        icon: ChartPieIcon,
      },
      {
        name: "Traffic sources",
        href: "traffic",
        current: false,
        icon: UserGroupIcon,
      },
      // {
      //   name: "Cohort Insights",
      //   href: "cohort-insight",
      //   current: false,
      //   icon: LightBulbIcon,
      // },
      {
        name: "Ads leakage",
        href: "ads-leakage",
        current: false,
        icon: FunnelIcon,
      },
      // {
      //   name: "First touch last touch",
      //   href: "first-last-touch",
      //   current: false,
      //   icon: CursorArrowRaysIcon,
      // },
      {
        name: "Google Analytics",
        href: "Google-Analytics",
        current: false,
        icon: ChartBarIcon ,
      },
       {
        name: "Ads-Offline Conversion",
        href: "Ads-Offline-Conversion",
        current: false,
        icon: BookmarkSquareIcon ,
      },
    ],
  },
  {
    name: "Email Campaigns",
    current: false,
    icon: EnvelopeIcon,
    children: [
      {
        name: "Flows",
        href: "flows",
        current: false,
        icon: ArrowPathRoundedSquareIcon,
      },
      {
        name: "Email Template",
        href: "/flows/new-custom-nudge",
        current: false,
        icon: PaintBrushIcon,
      },
      
    ],
  },
  {
    name: "Traffic optimization",
    current: false,
    icon: PresentationChartLineIcon,
    children: [
      {
        name: "A/B Test Performance",
        href: "goals",
        current: false,
        icon: StopCircleIcon,
      },
        // {
        //   name: "Landing page editor",
        //   href: "landing-page-editor",
        //   current: false,
        //   icon: CodeBracketSquareIcon,
        // },
        {
          name: "Design Your Segments",
          href: "bandit-test",
          current: false,
          icon: CodeBracketSquareIcon,
        },
        {
          name: "User Segment Statistics",
          href: "heatmap",
          current: false,
          icon: LightBulbIcon,
        },
    ],
  },
  {
    name: "Chatbot",
    icon: CpuChipIcon,
    current: false,
    children: [
      {
        name: "Inbox",
        href: "chatbot",
        current: false,
        icon: PaperAirplaneIcon,
      },
      {
        name: "AI bot settings",
        href: "chatbot-settings",
        current: false,
        icon: CogIcon,
      },
      // {
      //   name: "AI Bot Analytics",
      //   href: "chatbot-analytics",
      //   current: false,
      //   icon: ChartBarSquareIcon,
      // },
      {
        name: "Data source",
        href: "data-source",
        current: false,
        icon: BuildingOfficeIcon,
      },
    ],
  },
  {
    name: "Booking Platform",
    icon: RocketLaunchIcon,
    current: false,
    // href: "booking",
    children: [
      {
        name: "Booking Calendar",
        href: "booking/user-details",
        current: false,
        icon: UserGroupIcon,
      },
      {
        name: "Booking Statistics",
        href: "booking/stats",
        current: false,
        icon: ChartBarSquareIcon,
      },
      {
        name: "Products & Availability",
        href: "booking/products",
        current: false,
        icon: ClipboardDocumentCheckIcon,
      },
      {
        name: "Platform Settings",
        href: "booking/platform-settings",
        current: false,
        icon: CogIcon,
      },
    ],
  },
  {
    name: "Settings",
    icon: Cog6ToothIcon,
    current: false,
    children: [
      {
        name: "Admin view",
        href: "settings",
        current: false,
        icon: ViewfinderCircleIcon,
      },
      {
        name: "Change password",
        href: "change-password",
        current: false,
        icon: ShieldCheckIcon,
      },
      {
        name: "Integrations",
        href: "integration",
        current: false,
        icon: Squares2X2Icon,
      },
      {
        name: "Help",
        href: "help",
        current: false,
        icon: InformationCircleIcon,
      },
    ],
  },
];

export default function NewSidebar() {
  const location = useLocation();
  const [openParent, setOpenParent] = useState(null);

  const [navigation, setNavigation] = useState(navigationObj);

  const handleSetRouteActive = useCallback((data, subRoute) => {
    return data.map((item) => {
      if (item.children) {
        let subRouteData = handleSetRouteActive(item.children, subRoute);
        let isSubRouteExists = subRouteData.some((item) => item.current);
        let res_data;
        if (isSubRouteExists) {
          res_data = { ...item, current: true, children: subRouteData };
          setOpenParent(item.name);
        } else {
          res_data = { ...item, current: false, children: subRouteData };
        }
        return res_data;
      } else {
        return {
          ...item,
          current: item.href === subRoute,
        };
      }
    });
  }, []);

  useEffect(() => {
    let subRoute = location.pathname.slice(1);
    setNavigation((prev) => handleSetRouteActive(prev, subRoute));
  }, [location.pathname]);

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r px-3 md:px-6 bg-[#172b4d] dark:bg-neutral-800 text-neutral-200 pt-3 max-w-xs">
      <nav className="flex flex-1 flex-col">
        <ul className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul className="-mx-2 space-y-1">
              {navigation?.map((item) => (
                <li key={item.name}>
                  {!item.children ? (
                    <NavLink
                      to={item.href}
                      title={item.name}  // Tooltip for mobile view
                      className={ClassNames(
                        item.current
                          ? "bg-[#213c6c]"
                          : "hover:bg-[#213c6c] hover:cursor-pointer",
                        "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold text-white"
                      )}
                    >
                      <item.icon
                        className="h-6 w-6 shrink-0 text-gray-300"
                        aria-hidden="true"
                      />
                      <span className="hidden md:inline">{item.name}</span>
                    </NavLink>
                  ) : (
                    <Disclosure>
                      {({ open }) => (
                        <>
                          <Disclosure.Button
                            className={ClassNames(
                              item.current
                                ? "bg-[#213c6c]"
                                : "hover:bg-[#213c6c]",
                              "flex items-center w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold text-white"
                            )}
                          >
                            <item.icon
                              className="h-6 w-6 shrink-0 text-gray-300"
                              aria-hidden="true"
                              title={item.name}  // Tooltip for mobile view
                            />
                            <span className="hidden md:inline">{item.name}</span>
                            <ChevronRightIcon
                              className={ClassNames(
                                open
                                  ? "rotate-90 text-gray-500"
                                  : "text-gray-400",
                                "ml-auto h-5 w-5 shrink-0"
                              )}
                              aria-hidden="true"
                            />
                          </Disclosure.Button>
                          <Disclosure.Panel as="ul" className="mt-1 px-2">
                            {item.children.map((subItem) => (
                              <li key={subItem.name}>
                                <NavLink
                                  to={subItem.href}
                                  title={subItem.name}
                                  className={ClassNames(
                                    subItem.current
                                      ? "bg-[#213c6c]"
                                      : "hover:bg-[#213c6c]",
                                    "flex rounded-md py-2 pr-2 pl-9 text-sm leading-6 text-white gap-1.5"
                                  )}
                                >
                                  {subItem.icon && (
                                    <subItem.icon
                                      className="h-6 w-6 shrink-0 text-gray-300"
                                      aria-hidden="true"
                                    />
                                  )}
                                  <span className="hidden md:inline">{subItem.name}</span>
                                </NavLink>
                              </li>
                            ))}
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  )}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
}